import { combineReducers } from "redux";
import { reducer as obterZonasGeo } from "./actions/obterZonasGeo";
import { reducer as obterAreasEspeciaisGeo } from "./actions/obterAreasEspeciaisGeo";
import { reducer as obterPlanoDiretorNoPonto } from "./actions/obterPlanoDiretorNoPonto";
import { reducer as obterZonaPorSigla } from "./actions/obterZonaPorSigla";
import { reducer as obterAnexo } from "./actions/obterAnexo";

export const consultaprevia = combineReducers({
  obterZonasGeo,
  obterAreasEspeciaisGeo,
  obterPlanoDiretorNoPonto,
  obterZonaPorSigla,
  obterAnexo
});
